import { updateLinksAttributes } from '../../../utils/handleAttributes';

export default function fairHotButons() {
  const widgetName = 'fairHotButons';
  const widgetOpts = fairHotButonsOpts;
  const $widget = $(`#${widgetName}`);

  return saffire.widgets.cardWidget($($widget), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    link: ['all'],
    showDescription: true,
    moreButton: true,
    hasImages: true,
    lazyLoadImages: true,
    imageIsBackground: true,
    textOverImage: true,
    maxItemsVisible: 4,
    itemsPerPanel: 1,
    buyNowButton: false,

    cardWidgetLoaded: function (data, _owl, hasData) {
      if (hasData) {
        createCustomHotButtons(data.items, $widget);
      } else {
        $(`#${widgetName}`).remove();
      }
    },
  });
}

function createCustomHotButtons(widgetData, $widget) {
  $widget.find('.card-widget-item').each(function (x) {
    const { Title, URL } = widgetData[x];
    const $cardItem = $(this);

    $cardItem.find('.card-content').remove();
    $cardItem.text(Title);

    updateLinksAttributes(URL, Title, $cardItem);
  });
}
